module.exports = __webpack_public_path__ + "static/media/Cats.a4c60322.png";